export const EL_BAR_DATA = [
    {
        name: 'EL1',
        emotion: 'Intense',
        value: 80
    },
    {
        name: 'EL2',
        emotion: 'Strong',
        value: 65
    },
    {
        name: 'EL3',
        emotion: 'Powerful',
        value: 45
    },
    {
        name: 'EL4',
        emotion: 'Lighter',
        value: 60
    },
    {
        name: 'EL5',
        emotion: 'Joy',
        value: 30
    }
];

export const EL_AREA_DATA = [
    {
        name: 'EL1',
        value: 120
    },
    {
        name: 'EL2',
        value: 65
    },
    {
        name: 'EL3',
        value: 45
    },
    {
        name: 'EL4',
        value: -60
    },
    {
        name: 'EL5',
        value: -110
    }
];

export const NEUROTRANSMITTER_DATA = [
    {
        dopamine: 10,
        cortisol: 5,
        serotonin: 9
    },
    {
        dopamine: 8,
        cortisol: 19,
        serotonin: 35
    },
    {
        dopamine: 50,
        cortisol: 35,
        serotonin: 15
    }
];

export const EL_RESONANCE_DATA = [
    {
        vision: 10,
        hearing: 5,
        smell: 9,
        taste: 8,
        touch: 13
    }, {
        vision: 25,
        hearing: 35,
        smell: 12,
        taste: 32,
        touch: 25
    },
    {
        vision: 24,
        hearing: 35,
        smell: 15,
        taste: 10,
        touch: 19
    },
];